import { ChangeEvent, CSSProperties, HtmlHTMLAttributes, ReactNode, useRef } from 'react';
import classNames from 'classnames';
import { getUUID } from 'utils/common';

interface CheckboxProps extends HtmlHTMLAttributes<HTMLInputElement> {
  className?: string;
  wrapClassName?: string;
  checked: boolean;
  label?: ReactNode;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  labelStyle?: CSSProperties;
}

function Checkbox({ className, wrapClassName, checked, label, disabled = false, labelStyle, ...props }: CheckboxProps) {
  const checkboxIdRef = useRef(`checkbox-${getUUID()}`);
  const checkbox = (
    <div className={classNames('flex flex-row items-center mr-3', className)}>
      <input
        data-durable-id="checkboxInputLinkId"
        data-intercom-target="checkboxInputLinkId"
        id={checkboxIdRef.current}
        type="checkbox"
        checked={checked}
        className="border-none absolute whitespace-nowrap p-0 overflow-hidden"
        style={{ clip: 'rect(0,0,0,0)', clipPath: 'inset(50%)', height: 1, margin: -1, width: 1 }}
        onChange={props.onChange}
        disabled={disabled || null}
        {...props}
      />
      <div
        className={classNames(
          'inline-block rounded cursor-pointer border border-charcoal-500',
          checked ? `bg-black` : `bg-charcoal-50`,
          { 'opacity-50 border-glooMedGray': disabled },
        )}
        style={{ height: 20, width: 20 }}
      >
        <svg
          className={classNames({ visible: checked, hidden: !checked })}
          style={{ stroke: 'white', fill: 'none', strokeWidth: 2 }}
          viewBox="0 0 24 24"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
    </div>
  );
  return (
    <label
      htmlFor={checkboxIdRef.current}
      style={labelStyle}
      className={classNames('flex flex-row items-center text-sm', { 'opacity-50': disabled }, wrapClassName)}
    >
      {checkbox}
      {label}
    </label>
  );
}

export default Checkbox;
